import { render } from "./FacilityExternalIdModal.vue?vue&type=template&id=5caff888&ts=true"
import script from "./FacilityExternalIdModal.vue?vue&type=script&lang=ts"
export * from "./FacilityExternalIdModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__